module.exports = __webpack_public_path__ + "img/screwdriver-wrench.8f735d13.svg";